import { TableBody, TableCell, TableRow } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useStyles from './styles';

const ActivityLogBody = ({ activityLogs = [], loading = false }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const language = useSelector((state) => state?.language?.currentLanguage);

  const formatTimestamp = (timestamp) => {
    try {
      const date = new Date(timestamp);
      const isEn = (i18n?.language || '').toLowerCase().startsWith('en');
      const formatter = new Intl.DateTimeFormat(i18n?.language || 'en', {
        timeZone: 'Asia/Ho_Chi_Minh',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: isEn,
      });
      return formatter.format(date);
    } catch (error) {
      return timestamp; // Fallback to original if formatting fails
    }
  };

  const renderDescription = (logEntry) => {
    const isEn = (i18n?.language || language || '').toLowerCase().startsWith('en');
    const content = isEn ? logEntry?.content_en : logEntry?.content_vi;
    return <div className={classes.description}>{content || ''}</div>;
  };

  if (loading) {
    return (
      <TableBody>
        <TableRow>
          <TableCell
            colSpan={3}
            className={classes.emptyCell}
          >
            <div className={classes.emptyState}>
              <CircularProgress size={24} />
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  if (!activityLogs || activityLogs.length === 0) {
    return (
      <TableBody>
        <TableRow>
          <TableCell
            colSpan={3}
            className={classes.emptyCell}
          >
            <div className={classes.emptyState}>
              <div className={classes.emptyIcon}>📋</div>
              <div className={classes.emptyMessage}>{t('no_activity_recorded')}</div>
              <div className={classes.emptySubMessage}>{t('activity_logs_will_appear_here')}</div>
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody>
      {activityLogs.map((logEntry, index) => (
        <TableRow
          key={logEntry.id || index}
          className={classes.row}
        >
          {/* Inventory code column */}
          <TableCell className={classes.cell}>
            <div className={classes.timestamp}>{logEntry?.params?.inventory_code || ''}</div>
          </TableCell>

          {/* Description column */}
          <TableCell className={classes.cell}>{renderDescription(logEntry)}</TableCell>

          {/* Timestamp column */}
          <TableCell className={classes.cell}>
            <div className={classes.timestamp}>{formatTimestamp(logEntry.created_at)}</div>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default ActivityLogBody;
